import { useEffect } from 'react'

//뒤로가기 대신 다른 액션을 하게 만드는 훅
export function useCustomBackAction(onBack: () => void) {
  useEffect(() => {
    const handlePopState = (e: PopStateEvent) => {
      e.preventDefault()
      onBack()

      // 히스토리 되돌림: 다시 앞으로 push
      window.history.pushState(null, '', window.location.pathname)
    }

    // 처음에 pushState로 현재 위치를 저장
    window.history.pushState(null, '', window.location.pathname)
    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [onBack])
}
